import { ReactNode } from 'react';
import { SidebarProvider, SidebarInset, Sidebar } from '@/components/ui/sidebar';
import { AdminSidebar } from '@/components/admin/AdminSidebar';
import DashboardHeader from '@/components/DashboardHeader';
import { usePanelLocale } from '@/hooks/usePanelLocale';

interface AdminLayoutProps {
  children: ReactNode;
}

/**
 * AdminLayout - App shell layout for admin panel
 * - Sticky top header (Navigation)
 * - Fixed left sidebar
 * - Scrollable main content area
 * 
 * IMPORTANT: Admin panel is ALWAYS English + LTR by business decision.
 * DO NOT modify this behavior when adding new locales.
 */
export function AdminLayout({ children }: AdminLayoutProps) {
  // Force English + LTR for admin panel
  usePanelLocale();

  return (
    <SidebarProvider defaultOpen={false}>
      {/* 
        Admin Panel: Always English + LTR 
        The force-ltr class ensures proper direction even if parent has RTL
      */}
      <div className="flex min-h-screen w-full bg-background force-ltr" dir="ltr" lang="en">
        <AdminSidebar />
        
        <SidebarInset className="flex-1 flex flex-col w-full">
          <DashboardHeader title="Admin" />
          
          <main className="flex-1 overflow-y-auto">
            <div className="container mx-auto p-4 sm:p-6 max-w-full">
              {children}
            </div>
          </main>
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
}
